import styled from 'styled-components';

const WhiteArrowRightStyled = styled.img`
  height: 10px;
  width: 10px;
`;

export default WhiteArrowRightStyled;